import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../requests';

type UseDeleteStrategyConfigs = {
  onReject?: UseMutationConfig<any>['onReject'];
  onSuccess?: UseMutationConfig<any>['onSuccess'];
};

export default function useDeleteStrategyQuery({
  onSuccess,
  onReject,
}: UseDeleteStrategyConfigs) {
  const {
    execute: deleteStrategy,
    isPending: isLoadingDeleteStrategy,
    ...query
  } = useMutation(API.deleteOptionStrategy, {
    onSuccess,
    onReject,
  });

  return { deleteStrategy, isLoadingDeleteStrategy, ...query };
}
